import React, { useState, useEffect, useContext } from 'react';
import { AddBox } from '@mui/icons-material';

import ModalAddEditUser from './components/ModalAddEditUser';
import ModalAsignarGrupo from './components/ModalAsignarGrupo';

import { ModalGeneral, Tabla } from 'ui-component';
import headers from './components/headers';
import LayautContext from 'Context/ContextLayaut';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import { ServiciosCurso, ModalCostosGrupo } from './components';
import ModalFechasCurso from './components/ModalFechasCurso';

const Curso = ({ permisos, onCambioNivel, ...props }) => {
    const context = useContext(LayautContext);
    const serviciosCursos = ServiciosCurso();

    const [curso, setCurso] = useState([]);
    const [ctl, setCtl] = useState({ estatusCurso: [] });
    const [confirm, setConfirm] = useState({ open: false });
    const [modal, setModal] = useState({ open: false, titulo: '' });
    const [modalAsignarGrupo, setModalAsignarGrupo] = useState({ open: false, titulo: '', row: {} });

    const actualizarData = (nuevaCurso = []) => {
        if (!nuevaCurso || nuevaCurso.length === 0) return;

        const cursoFormato = nuevaCurso.map((cursoObj) => {
            const areasCurso = cursoObj.areas?.split(',') || [];
            return {
                ...cursoObj,
                areas: ctl.areas?.filter((area) => areasCurso.includes(area.idarea)) || []
            };
        });

        setCurso((cursoActual) => {
            const copia = [...cursoActual];
            const ids = copia.map((oc) => oc.idCurso);
            cursoFormato.forEach((cursoNuevo) => {
                const indice = ids.indexOf(cursoNuevo.idCurso);
                if (indice >= 0) copia.splice(indice, 1, cursoNuevo);
                else copia.splice(0, 0, cursoNuevo);
            });
            return copia;
        });
    };
    const abrirEditarCurso = (row) => {
        row = {
            ...row,
            estatusCurso: {
                idEstatus: row.idCursoEstatus,
                nCursoEstatus: row.nCursoEstatus
            },
            extemporaneo: row.extemporaneo === 'Si' ? '1' : '0',
            interno: row.interno === 'Si' ? '1' : '0',
            obligatorio: row.obligatorio === 'Si' ? '1' : '0',
            puesto: row.npuesto ? { idpuesto: row.idpuesto, npuesto: row.npuesto } : null
        };
        context.formulario.abrir({
            open: true,
            propsForm: { data: row, ctl: ctl, userInfo: props.usuario, clasificacionCurso: ctl.clasificacionCurso },
            formulario: ModalAddEditUser,
            aceptar: (dataForm) => {
                const dataFormAuxiliar = { ...dataForm };
                dataFormAuxiliar.clasificacionCurso = JSON.stringify(dataFormAuxiliar.clasificacionCurso);
                const formData = new FormData();
                formData.append('idCurso', row.idCurso);
                Object.keys(dataFormAuxiliar).forEach((key) => {
                    if (key !== 'portadaCurso') formData.append(key, dataFormAuxiliar[key]);
                });
                formData.append('portadaCurso', dataFormAuxiliar.portadaCurso?.file);

                serviciosCursos.updateCurso((res) => {
                    actualizarData(res.curso);
                    context.formulario.cerrar();
                }, formData);
            }
        });
    };

    const abrirAsignarGrupo = (row) => {
        context.formulario.abrir({
            open: true,
            titulo: 'Asignar grupos',
            width: 'sm',
            propsForm: { data: row, ctl: ctl },
            formulario: ModalAsignarGrupo,
            btnAceptarName: 'Continuar',
            mensajeConfirmacion: '',
            aceptar: (formularioGrupos) => {
                if (!formularioGrupos.grupoSelected || formularioGrupos.grupoSelected.length === 0) {
                    context.mensaje({ open: true, status: -1, value: 'No hay ningún grupo seleccionado.' });
                    return false;
                }

                context.formulario.cerrar();

                setTimeout(() => {
                    context.formulario.abrir({
                        open: true,
                        titulo: 'Periodo a cursar',
                        width: 'xs',
                        propsForm: {},
                        formulario: ModalFechasCurso,
                        mensajeConfirmacion: '¿Está seguro de asignar el curso con estas fechas a los grupos seleccionados?',
                        aceptar: (formularioFechas) => {
                            if (!formularioFechas.fechaInicioCurso || !formularioFechas.fechaFinCurso) {
                                context.mensaje({ open: true, status: -1, value: 'Debe seleccionar ambas fechas.' });
                                return false;
                            }

                            const fechaInicio = new Date(formularioFechas.fechaInicioCurso);
                            const fechaFin = new Date(formularioFechas.fechaFinCurso);

                            if (fechaFin <= fechaInicio) {
                                context.mensaje({ open: true, status: -1, value: 'La fecha de fin debe ser mayor a la fecha de inicio.' });
                                return false;
                            }

                            const formatearFecha = (fecha) => {
                                const d = new Date(fecha);
                                const year = d.getFullYear();
                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                const day = String(d.getDate()).padStart(2, '0');
                                const hours = String(d.getHours()).padStart(2, '0');
                                const minutes = String(d.getMinutes()).padStart(2, '0');
                                const seconds = String(d.getSeconds()).padStart(2, '0');
                                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                            };

                            const datosCompletos = {
                                grupoSelected: formularioGrupos.grupoSelected,
                                observaciones: formularioGrupos.observaciones || '',
                                fechaInicioCurso: formatearFecha(formularioFechas.fechaInicioCurso),
                                fechaFinCurso: formatearFecha(formularioFechas.fechaFinCurso)
                            };

                            serviciosCursos.agregarGrupoCurso(
                                (res) => {
                                    context.formulario.cerrar();
                                    context.mensaje({ open: true, status: res.status === 1 ? 1 : -1, value: res.mensaje });
                                },
                                { curso: row, formulario: datosCompletos }
                            );
                        }
                    });
                }, 300);
            }
        });
    };

    const abrirNuevoCurso = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            propsForm: { data: null, ctl: ctl, userInfo: props.usuario, clasificacionCurso: ctl.clasificacionCurso },
            formulario: ModalAddEditUser,
            aceptar: (dataForm) => {
                const dataFormAuxiliar = { ...dataForm };
                dataFormAuxiliar.clasificacionCurso = JSON.stringify(dataFormAuxiliar.clasificacionCurso);
                const formData = new FormData();
                Object.keys(dataFormAuxiliar).forEach((key) => {
                    if ((key !== 'portadaCurso', dataFormAuxiliar)) formData.append(key, dataFormAuxiliar[key]);
                });
                formData.append('portadaCurso', dataFormAuxiliar.portadaCurso?.file);
                serviciosCursos.insertCurso((data) => {
                    // Solo llega aquí si status === 1
                    actualizarData(data?.curso || []);
                    context.formulario.cerrar();
                }, formData);
            }
        });
    };

    const abrirConfirmarCambio = (usuario) => (e) => {
        let texto = `¿Estás seguro de volver a activar al usuario ${usuario.usuario}?`;
        let status = 1;
        if (usuario.idestatus === '1') {
            texto = `¿Estás seguro de desactivar al usuario ${usuario.usuario}, un usuario inactivo no puede ingresar al sistema?`;
            status = 0;
        }
        setConfirm({
            open: true,
            text: texto,
            aceptar: () =>
                serviciosCursos.cambiarEstatusCurso(
                    (nuevaData) => {
                        actualizarData(nuevaData.usuarios);
                        setConfirm({ open: false });
                    },
                    { idUser: usuario.idCurso, idestatus: status }
                )
        });
    };

    const abrirModalCurso = (curso) => {
        serviciosCursos.getCursoCosto(
            (res) => setModal({ open: true, titulo: `Costos del curso :${curso.titulo}`, curso: { ...curso, costo: res.cursoCosto } }),
            { idCurso: curso.idCurso }
        );
    };

    const cerrarModalCurso = () => setModal({ ...curso, open: false });
    const cerrarModalAsignarGrupo = () => setModalAsignarGrupo({ open: false, titulo: '', row: {} });

    const abreEliminarCurso = (item) => {
        setConfirm({
            open: true,
            text: `El curso ${item.titulo} ya no estará disponible para asignarse a colaboradores. ¿Desea continuar?`,
            aceptar: () =>
                serviciosCursos.borrarCurso(
                    (nuevaData) => {
                        let actuales = curso;
                        let idBorrar = actuales.findIndex((x) => x.idCurso == item.idCurso);
                        if (idBorrar != -1) {
                            actuales.splice(idBorrar, 1);
                            setCurso([...actuales]);
                        }
                        setConfirm({ open: false });
                    },
                    { idCurso: item.idCurso }
                )
        });
    };

    const duplicarCurso = (item) => {
        setConfirm({
            open: true,
            loading: false,
            text: `¿Deseas duplicar el curso "${item.titulo}"? Se creará una copia con el nombre "${item.titulo} (Duplicado)".`,
            aceptar: () => {
                setConfirm((prev) => ({ ...prev, loading: true }));

                serviciosCursos.duplicarCurso(
                    (res) => {
                        setConfirm({ open: false, loading: false });

                        if (res?.status === 1) {
                            //insertar nuevo registro en tabla al instante
                            const cursos = res?.data?.curso || [];
                            if (cursos.length > 0) actualizarData(cursos);
                            context.mensaje({ open: true, status: 1, value: res.mensaje });
                        } else {
                            //  -2 título duplicado  |   -1 error general
                            context.mensaje({ open: true, status: -1, value: res?.mensaje || 'Error al duplicar el curso.' });
                        }
                    },
                    { idCurso: item.idCurso }
                );
            }
        });
    };

    const acciones = [{ label: 'Nuevo Curso', icon: <AddBox />, click: abrirNuevoCurso, disabled: !permisos.crear }];

    const accionesFila = [
        { label: 'Sesiones', onClick: (cursoSeleccionado) => onCambioNivel(cursoSeleccionado, curso), enabled: true },
        { label: 'Editar', onClick: abrirEditarCurso, enabled: permisos.editar },
        { label: 'Asignar grupo', onClick: abrirAsignarGrupo, enabled: true },
        { label: 'Costos del curso', onClick: abrirModalCurso, enabled: true },
        { label: 'Duplicar curso', onClick: duplicarCurso, enabled: permisos.crear },
        { label: 'Eliminar Curso', onClick: abreEliminarCurso, enabled: (row) => Number(row.numAlumnos) == 0 && permisos.delCur }
    ];

    useEffect(() => {
        serviciosCursos.cursosInt((ct) => {
            if (ct.curso) {
                let cursoFormato = ct.curso?.map((cursoObj) => {
                    let areasCurso = cursoObj.areas?.split(',') || [];
                    return {
                        ...cursoObj,
                        areas: ct.areas?.filter((area) => areasCurso.includes(area.idarea))
                    };
                });
                if (!['1'].includes(props.usuario.idrol))
                    cursoFormato = cursoFormato.filter((curso) => {
                        let usuarioTieneArea = false;
                        let idAreasUsuario = props?.usuario?.areas?.map((area) => area.idarea) || [];
                        curso.areas.forEach((area) => {
                            if (idAreasUsuario.includes(area.idarea)) usuarioTieneArea = true;
                        });
                        return usuarioTieneArea;
                    });
                setCurso(cursoFormato || []);
            }
            setCtl({ ...ctl, estatusCurso: ct.estatusCurso || [], areas: ct.areas, clasificacionCurso: ct.clasificacionCurso || [] });
        });
    }, []);

    return (
        <>
            <Tabla
                rows={curso}
                columns={
                    props?.esVistaTrainer
                        ? headers(abrirConfirmarCambio, ctl, permisos).cursoTrainer
                        : headers(abrirConfirmarCambio, ctl, permisos).curso
                }
                accionesTabla={acciones}
                accionesFila={accionesFila}
                columnKey="idCurso"
            />
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
                loading={confirm.loading}
            />
            <ModalGeneral open={modal.open} width="lg" titulo={modal.titulo} OnCerrar={cerrarModalCurso}>
                <ModalCostosGrupo curso={modal.curso} />
            </ModalGeneral>
        </>
    );
};

export default Curso;
